const MAX_MINDMAP_INSTRUCTION_LENGTH = 4000;

export function buildMindmapInstructionInput(
  sourceText: string,
  instruction: string,
  locale: string
) {
  const source = sourceText.trim();
  const request = instruction.trim().slice(0, MAX_MINDMAP_INSTRUCTION_LENGTH);

  if (!source || !request) {
    return '';
  }

  return [
    'Create a mind map from the source block below.',
    'Follow the user instruction when choosing the hierarchy, grouping, depth, and emphasis.',
    'Do not answer with prose outside the mind map.',
    `Generate all mind-map node text in the interface language for locale "${locale}".`,
    '',
    'Source block:',
    source,
    '',
    'User instruction:',
    request,
    '',
    `Interface locale: ${locale}`,
  ].join('\n');
}
